/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyPeso = createReactComponent("currency-peso", "IconCurrencyPeso", [
  ["path", { d: "M8 19v-14h3.5a4.5 4.5 0 1 1 0 9h-3.5", key: "svg-0" }],
  ["path", { d: "M18 8h-12", key: "svg-1" }],
  ["path", { d: "M18 11h-12", key: "svg-2" }]
]);

export { IconCurrencyPeso as default };
//# sourceMappingURL=IconCurrencyPeso.js.map
